// General
import React from 'react';
import PropTypes from 'prop-types';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './LoginModal.css';
import cx from 'classnames';
import bt from '../../components/commonStyle.css';
import { Modal } from 'react-bootstrap';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { closeLoginModal, openSignupModal } from '../../actions/modalActions';

// Components
import SocialLogin from '../SocialLogin';
import LoginForm from '../LoginForm';
import Link from '../Link';

// Translation
import { FormattedMessage } from 'react-intl';

// Locale
import messages from '../../locale/messages';

const LoginModal = () => {

  const loginModal = useSelector(state => state.modalStatus.isLoginModalOpen);
  const dispatch = useDispatch();

  return (
    <>
      <Modal
        show={loginModal}
        animation={false}
        onHide={() => dispatch(closeLoginModal())}
        dialogClassName={'loginModal'}
      >
        <Modal.Header closeButton>
          <Modal.Title><FormattedMessage {...messages.logInSignUp} /></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={s.root}>
            <LoginForm />
            <h4 className={s.lineThrough}>
              <span className={cx(s.linetext)}><FormattedMessage {...messages.or} /></span>
            </h4>
            <SocialLogin />
            <p className={s.linkText}>
              <FormattedMessage {...messages.noAccount} />
              <Link className={s.modalCaptionLink} onClick={() => dispatch(openSignupModal())}>
                <FormattedMessage {...messages.signUpHere} />
              </Link>
            </p>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

LoginModal.propTypes = {
  closeLoginModal: PropTypes.func,
  loginModal: PropTypes.bool,
  openSignupModal: PropTypes.func,
  formatMessage: PropTypes.func,
};

export default withStyles(s, bt)(LoginModal);